import React, { useState, useEffect, useRef } from 'react';
import { useMemo } from 'react';
import _ from 'lodash';

import CallCostsComponent from './CallCostsComponent';
import TelecomServicesSection from './TelecomServiceSection'; 
import {  Phone, Mail, User, Building2, CheckCircle, AlertCircle, Search,  ChevronDown, ChevronUp, Settings, Wifi, Globe, Monitor, Smartphone, Headphones, Tablet, Plus, X, Edit2, CalculatorIcon  } from 'lucide-react';
import connectionService from '../services/connectionService';
import { fetchMechanicsData } from '../services/mechanicsService'; 
import AddConnection from './AddConnection';

import { 
  saveSystemConfig, 
  getSystemConfig,
  updateSystemConfig ,
  saveContractNotes,
} from '../services/systemConfigService';
import QuoteProgressService from '../services/quoteProgressService';
import { mergeNonEmpty } from '../utils/mergeNonEmpty';

 const getDefaultHardwareItems = () => [
    { id: 1, name: 'Bell / Tannoy', quantity: 0, focQuantity: 0, category: 'Audio', icon: '/images/bell.jpg' },
    { id: 2, name: 'Mobile App', quantity: 0, focQuantity: 0, category: 'Software', icon: '/images/mobileapp.jpg' },
    { id: 3, name: 'Mobile App Addon', quantity: 0, focQuantity: 0, category: 'Software', icon: '📱' },
    { id: 4, name: 'T54W', quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/t54w.png' },
    { id: 5, name: 'T57W', quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/t57w.jpg' },
    { id: 6, name: 'T58W', quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/t58w.jpg' },
    { id: 7,  name: 'YEALINK T85',      quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/yealinkt85.jpg'},   
    { id: 8,  name: 'YEALINK T87',      quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/T87W.jpg' },
    { id: 9,  name: 'YEALINK T88',      quantity: 0, focQuantity: 0, category: 'Phone',    icon: '/images/Yealink_new.jpg' },
    { id: 10,  name: 'Grandstream 3470', quantity: 0, focQuantity: 0, category: 'Phone',    icon: '/images/Grandstream_3470.jpg' },
    { id: 11,  name: 'Grandstream 3480', quantity: 0, focQuantity: 0, category: 'Phone',    icon: '/images/3480.jpg' },
    { id: 12, name: 'Cisco 9871',       quantity: 0,focQuantity: 0, category: 'Phone',    icon: '/images/CISCO.jpeg' },
    { id: 13, name: 'Yealink W73H DECT', quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/ipdect.jpg' },
    { id: 14, name: 'IP DECT Base', quantity: 0, focQuantity: 0, category: 'Phone', icon: '/images/ipdect.jpg' },
    { id: 15, name: 'Wi-Fi Booster', quantity: 0, focQuantity: 0, category: 'Network', icon: '/images/wifibooster.jpg' },
    { id: 16, name: 'Headsets', quantity: 0, focQuantity: 0, category: 'Audio', icon: '/images/headset.jpg' },
    { id: 17, name: 'Fibre TV/Wallboard', quantity: 0, focQuantity: 0, category: 'Display', icon: '/images/fibretv.jpg' },
    { id: 18, name: 'iPad', quantity: 0, focQuantity: 0, category: 'Tablet', icon: '/images/ipad.png' },
    { id: 19, name: 'Fibre Audio', quantity: 0,focQuantity: 0,  category: 'Audio', icon: '🎧' },
    { id: 20, name: 'Add On', quantity: 0,focQuantity: 0,  category: 'Display', icon: '/images/fibretv.jpg' },
  ];

  const getDefaultAdditionalHardware = () => [
    { id: 'fibre', name: 'Fibre', quantity: 1, focQuantity: 0, category: 'Music Module', icon: '/images/music.svg' },
    { id: 'media-player', name: 'Media Player', quantity: 1,focQuantity: 0,  category: 'Music Module', icon: '/images/module.svg' },
    { id: 'aa-voice-over', name: 'AA Voice Over', quantity: 1,focQuantity: 0,  category: 'Music Module', icon: '/images/music.svg' },
    { id: 'site-link-licence', name: 'Site Link Licence', quantity: 0,focQuantity: 0,  category: 'Site Link Licence', icon: '/images/sitelink.png' },
    { id: 'analogue-devices', name: 'Analogue Devices', quantity: 0, focQuantity: 0,category: 'Site Link Licence', icon: '/images/sitelink.png' },
    { id: 'ups', name: 'UPS', quantity: 1, focQuantity: 0, category: 'Protection', icon: '/images/protection.svg' },
    { id: 'surge-protection', name: 'Surge protection', quantity: 1, focQuantity: 0, category: 'Protection', icon: '/images/protection.svg' },
    { id: 'pancode', name: 'Pancode', quantity: 0, focQuantity: 0, category: 'Door entry', icon: '/images/doorentry.png' },
    { id: '1-button-entry', name: '1 Button Entry', quantity: 0, focQuantity: 0, category: 'Door entry', icon: '/images/doorentry.png' },
    { id: 'ucm-ip-pbx', name: 'UCM IP PBX', quantity: 1,focQuantity: 0,  category: 'UCM IP PBX', icon: '/images/ucmippbx.jpg' },
    { id: 'voicemail-ports', name: 'Voicemail ports', quantity: 0,focQuantity: 0,  category: 'UCM IP PBX', icon: '/images/ucmippbx.jpg' },
    { id: 'wifi-enabled', name: 'Draytek 2865LAC', quantity: 0, focQuantity: 0, category: 'Router', icon: '/images/router.png' },
    { id: '8-port-poe', name: 'Netgear GS108LP', quantity: 0,focQuantity: 0,  category: 'POE', icon: '/images/poe.png' },
    { id: '24-port-poe', name: '24 port POE', quantity: 0, focQuantity: 0, category: 'POE', icon: '/images/poe.png' },
    { id: 'cat5e-cable-5m', name: 'Cat 5E Cable (5m)', quantity: 0,focQuantity: 0,  category: 'Cabling', icon: '/images/cat5e.jpg' },
    { id: 'system-moves', name: 'System Moves', quantity: 0, focQuantity: 0, category: 'System Moves', icon: '/images/systemmoves.png' },
    { id: 'cat5', name: 'Cat 5', quantity: 0, focQuantity: 0, category: 'System Moves', icon: '/images/systemmoves.png' },
  ];

  const getDefaultLineRequirements = () => ({
    existingIsdn2Channels: 0,
    newConversionIsdn2Channel: 0,
    existingIsdn30Channels: 0,
    newIsdn30Channel: 0
  });

  const getDefaultCurrentLines = () => ({
    hostedLifetimeLicenses: 0,
    analoguePstnLines: 0,
    adslFttcBroadband: 0,
    new4g5gBroadband: 0,
    fttpSogeaBroadband: 0
  });

  const getDefaultDataBroadband = () => ({
    starlinkBroadband: 0,
    leasedLines: 0
  });

  const getDefaultServiceCharges = () => ({
    service_charge: 0,
    equipment_rentals: 0,
    broadband: 0,
    media: 0,
    maintenance: 0,
    utilities: 0
  });

  // ── DEFAULT digital services state ──
  const getDefaultDigitalServices = () => ({
    webHostingCost: 0,
    licenceServices: {},
    axoSignalPackage: null,
    totalNewDigitalCost: 0,
    totalFibreDigitalRevenue: 0,
  });

  const getDefaultItServices = () => ({
    numberOfStations: 0,
    selectedPackages: ['it_support'], // any combination of 'it_support' | 'basic' | 'standard' | 'premium'
    licenceQuantities: {},
  });

const ExistingSystemConfig = ({connection,selectedConnectionId,onBack,onConnectionUpdated,onDirtyChange  }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLineServicesOpen, setIsLineServicesOpen] = useState(false);
  const [isHardwareOpen, setIsHardwareOpen] = useState(false);
  const [isItServicesOpen, setIsItServicesOpen] = useState(false);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const [configError, setConfigError] = useState(null);
  const [notes, setNotes] = useState('');
  
  const [showForm, setShowForm] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [emailExtraInput, setEmailExtraInput] = useState(0);

  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [autoCalculateMobileApp, setAutoCalculateMobileApp] = useState(true);
  const [error, setError] = useState(null);
  const [services, setServices] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [itSupportPricing, setItSupportPricing] = useState([]);

  const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [adminUpdate, setUpdatedByAdmin] = useState(false);

  // Track whether there are unsaved changes
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [savedOnce, setSavedOnce] = useState(false);

  useEffect(() => {
  if (typeof onDirtyChange === 'function') onDirtyChange(hasUnsavedChanges);
}, [hasUnsavedChanges, onDirtyChange]);

// Clear the flag in the parent when this screen unmounts (e.g. after a successful save + onBack)
useEffect(() => {
  return () => { if (typeof onDirtyChange === 'function') onDirtyChange(false); };
}, []);
useEffect(() => {
  if (!hasUnsavedChanges) return;
  const handler = (e) => { e.preventDefault(); e.returnValue = ''; };
  window.addEventListener('beforeunload', handler);
  return () => window.removeEventListener('beforeunload', handler);
}, [hasUnsavedChanges]);

  // ── Ref to suppress the router-total effect on initial data load ──
  const isInitialLoad = useRef(true);

  const [hardwareItems, setHardwareItems] = useState(getDefaultHardwareItems());
  const [additionalHardware, setAdditionalHardware] = useState(getDefaultAdditionalHardware());
  const [lineRequirements, setLineRequirements] = useState(getDefaultLineRequirements());
  const [currentLines, setCurrentLines] = useState(getDefaultCurrentLines());
  const [dataBroadband, setDataBroadband] = useState(getDefaultDataBroadband());
  const [serviceChargesData, setServiceChargesData] = useState(getDefaultServiceCharges());
  const [itServicesData, setItServicesData] = useState(getDefaultItServices());
  const [existingConfigId, setExistingConfigId] = useState(null);
  const [progress, setProgress] = useState([]);
  const [savedDigitalServices, setSavedDigitalServices] = useState(null);
  const [showEditConnection, setShowEditConnection] = useState(false);
  const [localConnection, setLocalConnection] = useState(connection);
  const [selectedPhoneModel, setSelectedPhoneModel] = useState('');
  const [focDraftValues, setFocDraftValues] = useState({});

  const [newItem, setNewItem] = useState({
    name: '',
    quantity: 0,
    category: 'Phone',
    icon: '📞'
  });

  const categories = [
    { name: 'Phone', icon: '📞' },
    { name: 'Audio', icon: '🔔' },
    { name: 'Network', icon: '📶' },
    { name: 'Display', icon: '📺' },
    { name: 'Tablet', icon: '📱' },
    { name: 'Software', icon: '💻' },
    { name: 'Other', icon: '⚙️' }
  ];
  const [currentUser, setCurrentUser] = useState({ id: null, name: null, role: null });
   //console.log('[PROP] selectedConnectionId =', selectedConnectionId, typeof selectedConnectionId)

  const getIconComponent = (category) => {
    switch (category) {
      case 'Phone': return <Phone className="w-5 h-5" />;
      case 'Audio': return <Headphones className="w-5 h-5" />;
      case 'Network': return <Wifi className="w-5 h-5" />;
      case 'Display': return <Monitor className="w-5 h-5" />;
      case 'Tablet': return <Tablet className="w-5 h-5" />;
      case 'Software': return <Smartphone className="w-5 h-5" />;
      default: return <Monitor className="w-5 h-5" />;
    }
  };

  const [telecomServices, setTelecomServices] = useState([
     {
       id: Date.now(),
       description: '',
       service_type: '',
       existing_tel_no: '',
       quantity: '',
       postcode: ''
     }
   ]);

  // ── Digital services state (lifted from CallCostsComponent) ──
  const [digitalServicesData, setDigitalServicesData] = useState(getDefaultDigitalServices());

  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const [isSettlementOpen, setIsSettlementOpen] = useState(false);
  const [settlement, setSettlement] = useState({
    existingFinanceCompany: '',
    existingAgreementRef: '',
    settlementAmount: '',
  });
  const [isSpecialTermsOpen, setIsSpecialTermsOpen] = useState(false);
  const [specialConditions, setSpecialConditions] = useState('');
  const [linesFoc, setLinesFoc] = useState({
      hostedLifetimeLicenses: false,
      hostedLifetimeLicensesFocQty: 0,
      new4g5gBroadband: false,
      new4g5gBroadbandFocQty: 0,
      fttpSogeaBroadband: false,
      fttpSogeaBroadbandFocQty: 0,
      starlinkBroadband: false,
      starlinkBroadbandFocQty: 0,
      leasedLines: false,
      leasedLinesFocQty: 0,
    });
  const handleDigitalServicesUpdate = (data) => {
    setDigitalServicesData(data);
    setHasUnsavedChanges(true);
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = telecomServices.map((service, i) => 
      i === index ? { ...service, [field]: value } : service
    );
    setTelecomServices(updatedServices);
    setHasUnsavedChanges(true);
  };

  const handleAddService = () => {
    setTelecomServices([
      ...telecomServices,
      {
        id: Date.now(),
        description: '',
        service_type: '',
        existing_tel_no: '',
        quantity: '',
        postcode: ''
      }
    ]);
    setHasUnsavedChanges(true);
  };

  const handleRemoveService = (index) => {
    if (telecomServices.length > 1) {
      setTelecomServices(telecomServices.filter((_, i) => i !== index));
      setHasUnsavedChanges(true);
    }
  };
  useEffect(() => {
    setLocalConnection((prev) => {
      if (!connection) return prev;
      if (!prev || prev.id !== connection.id) return connection; // switching to a different record
      return mergeNonEmpty(prev, connection); // same record — don't let a thin re-render wipe local data
    });
  }, [connection]);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('userName');
    const userRole = localStorage.getItem('Role');

    setCurrentUser({
      id: userId,
      name: userName,
      role: userRole
    });
  }, []);

    useEffect(() => {
    if (!selectedConnectionId) return;
    const loadSettlement = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/rental-settlement/${selectedConnectionId}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        const json = await res.json();
        if (json?.data) {
          setSettlement({
            existingFinanceCompany: json.data.existing_finance_company || '',
            existingAgreementRef:   json.data.existing_agreement_ref   || '',
            settlementAmount:       json.data.settlement_amount != null ? String(json.data.settlement_amount) : '',
          });
        }
      } catch (e) {
        console.error('Failed to load settlement details:', e);
      }
    };
    loadSettlement();
  }, [selectedConnectionId]);



  // ── leaseCalculatorData — digital_services initialised to null ──
  const [leaseCalculatorData, setLeaseCalculatorData] = useState({
    paymentProfile: '84',
    networkPayment: '12',
    discountLoad: 0,
    currentCallCharges: 0,
    estimatedCallCharges: 0,
    networkSettlementContribution: '0',
    adjustedRental: 0,
    actualLeasePayment: 0,
    actualProfit: 0,
    salesRepCommission: 0,
    current_lease_rental: 0,
    current_mobile_charges: 0,
    current_service_charges: 0,
    current_maintenance: 0,
    other_charges: 0,
    current_total_cost: 0,
    estimated_mobile_charges: 0,
    new_service_charges: 0,
    leased_line: 0,
    it_service_charge: 0,
    digital_services: null,
  });

  const canSeeFoc = currentUser.role !== 'Team Member';
 

  // ── Effect to load existing configuration data ──
  useEffect(() => {
    const fetchConfigData = async () => {
      if (!selectedConnectionId) {
        setDataLoaded(true);
        setIsExistingCustomer(false);
        return;
      }
   
      setIsLoadingConfig(true);
      setConfigError(null);
      
      try {
        const configData = await getSystemConfig(selectedConnectionId);
        if (configData.data.updated_by_admin !== undefined) {
          setUpdatedByAdmin(configData.data.updated_by_admin ? 1 : 0);
        }
        
        if (configData && Object.keys(configData).length > 0) {
          setIsExistingCustomer(true);
          
          setLineRequirements({
            ...getDefaultLineRequirements(),
            ...(configData.data.lineRequirements || {})
          });
          
          setCurrentLines({
            ...getDefaultCurrentLines(),
            ...(configData.data.currentLines || {})
          });
          
          setDataBroadband({
            ...getDefaultDataBroadband(),
            ...(configData.data.dataBroadband || {})
          });
          
          setNotes(configData.data.notes || '');
          setSpecialConditions(configData.data.special_conditions || '');

          setItServicesData({
            ...getDefaultItServices(),
            ...(configData.data.itServices || {})
          });

          // ── Build mergedItems first so we can derive mobileFocQty from it ──
          let mergedItems = getDefaultHardwareItems();

          if (configData.data.hardwareItems && Array.isArray(configData.data.hardwareItems)) {
            const defaultItems = getDefaultHardwareItems();
            const norm = (s) => (s || '').trim().toLowerCase();

            mergedItems = configData.data.hardwareItems.map(savedItem => {
              const defaultItem = defaultItems.find(d => norm(d.name) === norm(savedItem.name)) || {
                id: savedItem.id || Date.now(),
                category: savedItem.category || 'Other',
                icon: '⚙️'
              };
              return {
                ...defaultItem,
                ...savedItem,
                name: defaultItem.name || savedItem.name,
                category: defaultItem.category || savedItem.category || 'Other',
                icon: defaultItem.icon || savedItem.icon || '⚙️',
                quantity: typeof savedItem.quantity === 'number' ? savedItem.quantity : 0,
                focQuantity: typeof savedItem.focQuantity === 'number' ? savedItem.focQuantity : 0,
                foc: savedItem.foc === true || savedItem.foc === 1 ? true : false,
              };
            });

            // Add any default item the backend didn't return (e.g. Grandstream 3470/3480, Cisco 9871)
            defaultItems.forEach(def => {
              if (!mergedItems.find(i => norm(i.name) === norm(def.name))) {
                mergedItems.push({ ...def });
              }
            });

            // Keep display order the same as getDefaultHardwareItems
            const defaultOrder = defaultItems.map(d => norm(d.name));
            mergedItems.sort((a, b) => {
              const ia = defaultOrder.indexOf(norm(a.name));
              const ib = defaultOrder.indexOf(norm(b.name));
              return (ia === -1 ? Infinity : ia) - (ib === -1 ? Infinity : ib);
            });
          }

          setHardwareItems(mergedItems);

          // ── Derive mobileFocQty from merged items, then set linesFoc ──
          const mobileFocQty = mergedItems.find(i => i.name === 'Mobile App')?.focQuantity || 0;
          const savedLinesFoc = configData.data.linesFoc;

          setLinesFoc(savedLinesFoc
            ? {
                ...savedLinesFoc,
                hostedLifetimeLicensesFocQty: savedLinesFoc.hostedLifetimeLicensesFocQty ?? mobileFocQty,
              }
            : {
                hostedLifetimeLicenses: false, hostedLifetimeLicensesFocQty: mobileFocQty,
                new4g5gBroadband: false, new4g5gBroadbandFocQty: 0,
                fttpSogeaBroadband: false, fttpSogeaBroadbandFocQty: 0,
                starlinkBroadband: false, starlinkBroadbandFocQty: 0,
                leasedLines: false, leasedLinesFocQty: 0,
              }
          );
          //console.log('🔥 additionalHardware check', configData.data.additionalHardware);
          if (configData.data.additionalHardware && Array.isArray(configData.data.additionalHardware)) {
            const defaultAdditionalItems = getDefaultAdditionalHardware();

            const toNum = (v, fallback = 0) => {
              const n = Number(v);
              return Number.isFinite(n) ? n : fallback;
            };

            // Dedupe by normalized name — keep the entry with the highest quantity
            // (guards against stale duplicate hardware_item rows on the backend)
            const byName = new Map();
            configData.data.additionalHardware.forEach(savedItem => {
              const key = (savedItem.name || '').trim().toLowerCase();
              const existing = byName.get(key);
              if (!existing || toNum(savedItem.quantity) > toNum(existing.quantity)) {
                byName.set(key, savedItem);
              }
            });

            const mergedAdditionalItems = Array.from(byName.values()).map(savedItem => {
              const defaultItem = defaultAdditionalItems.find(
                d => d.name.trim().toLowerCase() === (savedItem.name || '').trim().toLowerCase()
              ) || {
                id: savedItem.id || Date.now(),
                name: savedItem.name || savedItem.description || 'Unknown Item',
                category: savedItem.category || 'Other',
                icon: '⚙️'
              };

              const quantity = toNum(savedItem.quantity, 0);
              const focQuantity = toNum(savedItem.focQuantity, 0);

              if (savedItem.name && (savedItem.name === 'Netgear GS108LP' || savedItem.name === 'Draytek 2865LAC')) {
                console.log('[router item reload]', savedItem.name, {
                  rawQuantity: savedItem.quantity,
                  parsedQuantity: quantity,
                  manuallySet: savedItem.manuallySet,
                });
              }

              return {
                ...defaultItem,
                ...savedItem,
                icon: defaultItem.icon || savedItem.icon || '⚙️',
                quantity,
                focQuantity,
                foc: savedItem.foc === true || savedItem.foc === 1 || savedItem.foc === '1',
                manuallySet: savedItem.manuallySet === true || savedItem.manuallySet === 1 || savedItem.manuallySet === '1',
              };
            });

            // Make sure every default item still appears even if backend omitted one
            defaultAdditionalItems.forEach(def => {
              if (!mergedAdditionalItems.find(i => i.name.trim().toLowerCase() === def.name.trim().toLowerCase())) {
                mergedAdditionalItems.push({ ...def });
              }
            });

            setAdditionalHardware(mergedAdditionalItems);
          
          } else {
            setAdditionalHardware(getDefaultAdditionalHardware());
          }
          
          setServiceChargesData({
            ...getDefaultServiceCharges(),
            ...(configData.data.serviceCharges || {})
          });

          if (configData.data.leaseCalculatorData) {
            setLeaseCalculatorData(prev => ({
              ...prev,
              ...configData.data.leaseCalculatorData,
              digital_services: configData.data.leaseCalculatorData.digital_services ?? null,
            }));
          
            if (configData.data.leaseCalculatorData.digital_services) {
              const ds = configData.data.leaseCalculatorData.digital_services;
          
              setDigitalServicesData({
                webHostingCost: ds.webHostingCost ?? 0,
                licenceServices: ds.licenceServices ?? {},
                axoSignalPackage: ds.axoSignalPackage ?? null,
                totalNewDigitalCost: ds.totalNewDigitalCost ?? 0,
                totalFibreDigitalRevenue: ds.totalFibreDigitalRevenue ?? 0,
              });
          
              setSavedDigitalServices(ds);
            }
          }

          if (configData.data.telecom_details && Array.isArray(configData.data.telecom_details)) {
            const loadedTelecomServices = configData.data.telecom_details.map((detail, index) => ({
              id: Date.now() + index,
              description: detail.description || '',
              service_type: detail.service_type || '',
              existing_tel_no: detail.existing_tel_no || '',
              quantity: detail.quantity || '',
              postcode: detail.postcode || detail.postcode_of_homeworker || ''
            }));
            
            setTelecomServices(loadedTelecomServices);
          } else {
            setTelecomServices([
              {
                id: Date.now(),
                description: '',
                service_type: '',
                existing_tel_no: '',
                quantity: '',
                postcode: ''
              }
            ]);
          }
          
          setExistingConfigId(configData.data.id);

          isInitialLoad.current = true;
          setHasUnsavedChanges(false);
          setSavedOnce(true);
        } else {
          setIsExistingCustomer(false);
        }
      } catch (error) {
        console.error('Failed to load config:', error);
        if (isExistingCustomer) {
          setConfigError('Failed to load configuration data');
        }
        setIsExistingCustomer(false);
      } finally {
        setIsLoadingConfig(false);
        setDataLoaded(true);
      }
    };

    fetchConfigData();
  }, [selectedConnectionId]);

  // ── Reset to defaults when connectionId changes ──
  useEffect(() => {
    if (!selectedConnectionId) {
      // Reset the initial-load gate so the router-total effect
      // doesn't immediately flag unsaved changes on next load.
      isInitialLoad.current = true;

      setHardwareItems(getDefaultHardwareItems());
      setAdditionalHardware(getDefaultAdditionalHardware());
      setLineRequirements(getDefaultLineRequirements());
      setCurrentLines(getDefaultCurrentLines());
      setDataBroadband(getDefaultDataBroadband());
      setServiceChargesData(getDefaultServiceCharges());
      setItServicesData(getDefaultItServices());
      setSavedDigitalServices(null);
      setDigitalServicesData(getDefaultDigitalServices());
      setTelecomServices([
        {
          id: Date.now(),
          description: '',
          service_type: '',
          existing_tel_no: '',
          quantity: '',
          postcode: ''
        }
      ]);
      setExistingConfigId(null);
      setIsExistingCustomer(false);
      setLinesFoc({
        hostedLifetimeLicenses: false, hostedLifetimeLicensesFocQty: 0,
        new4g5gBroadband: false, new4g5gBroadbandFocQty: 0,
        fttpSogeaBroadband: false, fttpSogeaBroadbandFocQty: 0,
        starlinkBroadband: false, starlinkBroadbandFocQty: 0,
        leasedLines: false, leasedLinesFocQty: 0,
      });
      setDataLoaded(true);
      setHasUnsavedChanges(false);
      setSavedOnce(false);
      setNotes('');
      setSpecialConditions('');
      setSettlement({ existingFinanceCompany: '', existingAgreementRef: '', settlementAmount: '' });
    }
  }, [selectedConnectionId]);

  const handleAddItem = () => {
    if (newItem.name.trim()) {
      const categoryData = categories.find(cat => cat.name === newItem.category);
      setHardwareItems([...hardwareItems, {
        id: Date.now(),
        ...newItem,
        icon: categoryData?.icon || '⚙️'
      }]);
      setNewItem({ name: '', quantity: 0, category: 'Phone', icon: '📞' });
      setShowAddForm(false);
      setHasUnsavedChanges(true);
    }
  };

  // ── Router-total effect ──
  // Uses isInitialLoad ref to silently apply the computed quantities on
  // the first run after data loads, without flagging unsaved changes.
useEffect(() => {
  const getMechanicsUcmIp = async () => {
    try {
      const response = await fetchMechanicsData();
      setServices(response.data.services);
      setEquipments(response.data.equipment);
      setLicenses(response.data.licenses || []);
      setItSupportPricing(response.data.it_support || []);
    } catch (error) {
      console.error('Failed to fetch UCM IP PBX:', error);
    }
  };

  getMechanicsUcmIp();

  if (dataLoaded) {
    const routerTotal =
      currentLines.adslFttcBroadband +
      currentLines.new4g5gBroadband +
      currentLines.fttpSogeaBroadband +
      dataBroadband.starlinkBroadband +
      dataBroadband.leasedLines;

    // Only auto-fill items the user hasn't manually overridden.
    setAdditionalHardware(prev =>
      prev.map(item =>
        (item.name === 'Draytek 2865LAC' || item.name === 'Netgear GS108LP') && !item.manuallySet
          ? { ...item, quantity: routerTotal }
          : item
      )
    );

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    } else {
      setHasUnsavedChanges(true);
    }
  }
}, [currentLines, dataBroadband, dataLoaded]);

  const totalEmails = useMemo(() => {
    const t54w = hardwareItems.find(item => item.name === 'T54W')?.quantity || 0;
    const t57w = hardwareItems.find(item => item.name === 'T57W')?.quantity || 0;
    const ipDectHandset = hardwareItems.find(item => item.name === 'Yealink W73H DECT')?.quantity || 0;
    return (parseInt(emailExtraInput) || 0) + t54w + t57w + ipDectHandset;
  }, [hardwareItems, emailExtraInput]);

  const handleLineRequirementChange = (field, value) => {
    setLineRequirements(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleCurrentLinesChange = (field, value) => {
    setCurrentLines(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleDataBroadbandChange = (field, value) => {
    setDataBroadband(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };
   const handleStationsChange = (value) => {
    setItServicesData(prev => ({
      ...prev,
      numberOfStations: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

 const handleTogglePackage = (key, checked) => {
    setItServicesData(prev => {
      const current = prev.selectedPackages || [];
      return {
        ...prev,
        selectedPackages: checked
          ? [...current, key]
          : current.filter(k => k !== key)
      };
    });
    setHasUnsavedChanges(true);
  };

  const handleLicenceQuantityChange = (licenseId, value) => {
    const qty = value === '' ? '' : parseInt(value) || 0;
    setItServicesData(prev => ({
      ...prev,
      licenceQuantities: { ...prev.licenceQuantities, [licenseId]: qty }
    }));
    setHasUnsavedChanges(true);
  };


  const handleEditItem = (id, field, value) => {
    const updatedItems = hardwareItems.map(item =>
      item.id === id
        ? { ...item, [field]: field === 'quantity' ? parseInt(value) || 0 : value }
        : item
    );

    const ipDectHandset = updatedItems.find(item => item.name === 'Yealink W73H DECT');
    const ipDectHandsetQty = ipDectHandset?.quantity || 0;

    const adjustedItems = updatedItems.map(item => {
      if (item.name === 'IP DECT Base') {
        return { ...item, quantity: ipDectHandsetQty > 0 ? 1 : 0 };
      }
      return item;
    });

    let mobileAppQty = adjustedItems.find(item => item.name === 'Mobile App')?.quantity || 0;

    if (autoCalculateMobileApp) {
      mobileAppQty = adjustedItems.reduce((sum, item) => {
        if (['T54W', 'T57W', 'T58W', 'Yealink W73H DECT', 'Mobile App Addon', 'YEALINK T88',
            'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871', 'YEALINK T85', 'YEALINK T87'
            ].includes(item.name)) {
          return sum + (item.quantity || 0);
        }
        return sum;
      }, 0);

      const mobileAppFocQty = adjustedItems.reduce((sum, item) => {
        if (['T54W', 'T57W', 'T58W', 'Yealink W73H DECT', 'Mobile App Addon', 'YEALINK T88',
            'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871', 'YEALINK T85', 'YEALINK T87'
            ].includes(item.name)) {
          return sum + (item.focQuantity || 0);
        }
        return sum;
      }, 0);

      // ── Preserve manually set Mobile App FOC if no handset FOCs exist
      const existingMobileAppFoc = adjustedItems.find(i => i.name === 'Mobile App')?.focQuantity || 0;

      adjustedItems.forEach(item => {
        if (item.name === 'Mobile App') {
          item.quantity = mobileAppQty;
          item.focQuantity = mobileAppFocQty > 0 ? mobileAppFocQty : existingMobileAppFoc;
        }
      });
    }

    const finalItems = adjustedItems;

    const voiceMail = finalItems.reduce((sum, item) => {
      if (['T54W', 'T57W', 'T58W', 'YEALINK T88', 'YEALINK T85', 'YEALINK T87',
          'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871'].includes(item.name)) {
        return sum + (item.quantity || 0);
      }
      return sum;
    }, 0);

const updatedAdditionalHardware = additionalHardware.map(item => {
  if (item.id === id) {
    const isRouterItem = item.name === 'Draytek 2865LAC' || item.name === 'Netgear GS108LP';
    return {
      ...item,
      [field]: field === 'quantity' ? parseInt(value) || 0 : value,
      ...(field === 'quantity' && isRouterItem ? { manuallySet: true } : {}),
    };
  }
  if (item.name === 'Voicemail ports') {
    return { ...item, quantity: voiceMail };
  }
  if (item.name === 'Cat 5E Cable (5m)') {
    const handsetSum = finalItems.reduce((sum, handsetItem) => {
      if (['T54W', 'T57W', 'T58W', 'Yealink W73H DECT', 'YEALINK T88', 'YEALINK T85', 'YEALINK T87',
          'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871'].includes(handsetItem.name)) {
        return sum + (handsetItem.quantity || 0);
      }
      return sum;
    }, 0);
    return { ...item, quantity: handsetSum };
  }
  return item;
});

    setHardwareItems(finalItems);
    setAdditionalHardware(updatedAdditionalHardware);
    setCurrentLines(prev =>
      prev.hostedLifetimeLicenses === mobileAppQty
        ? prev
        : { ...prev, hostedLifetimeLicenses: mobileAppQty }
    );
    setHasUnsavedChanges(true);
  };

const handleHardwareFocus = (id, field) => (e) => {};

  const handleHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
    handleEditItem(id, field, value);
  };

  const handleAdditionalHardwareFocus = (id, field) => (e) => {
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: '' } : item
    );
    setAdditionalHardware(updatedItems);
  };

  const handleAdditionalHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setAdditionalHardware(updatedItems);
    handleEditItem(id, field, value);
  };

  const handleDeleteItem = (id) => {
    setHardwareItems(hardwareItems.filter(item => item.id !== id));
    setHasUnsavedChanges(true);
  };
  const handleFocChange = (id, field, value, isAdditional = false) => {
    const updateItem = (item) => {
      if (item.id !== id) return item;
      if (field === 'foc' && !value) {
        return { ...item, foc: false, focQuantity: 0 };
      }
      return {
        ...item,
        [field]: field === 'focQuantity' ? parseInt(value) || 0 : value,
      };
    };

    if (isAdditional) {
      setAdditionalHardware(prev => prev.map(updateItem));
    } else {
      // ── Step 1: compute the updated hardware list synchronously ──
      setHardwareItems(prev => {
        const updated = prev.map(updateItem);
        const changedItem = updated.find(i => i.id === id);

        // If Mobile App's own FOC was changed, don't recalculate from handsets
        if (changedItem?.name === 'Mobile App') {
          return updated;
        }

        const HANDSET_NAMES = [
          'T54W', 'T57W', 'T58W', 'Yealink W73H DECT', 'Mobile App Addon',
          'YEALINK T88', 'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871',
          'YEALINK T85', 'YEALINK T87',
        ];

        const mobileAppFocQty = updated.reduce((sum, item) =>
          HANDSET_NAMES.includes(item.name) ? sum + (item.focQuantity || 0) : sum
        , 0);

        return updated.map(item =>
          item.name === 'Mobile App'
            ? { ...item, focQuantity: mobileAppFocQty, foc: mobileAppFocQty > 0 }
            : item
        );
      });

      // ── Step 2: sync linesFoc OUTSIDE the setHardwareItems updater ──
      // Read the freshest handset state to compute mobileAppFocQty again
      // (updater above closed over stale `hardwareItems` for this purpose)
      setHardwareItems(prev => {
        const HANDSET_NAMES = [
          'T54W', 'T57W', 'T58W', 'Yealink W73H DECT', 'Mobile App Addon',
          'YEALINK T88', 'Grandstream 3470', 'Grandstream 3480', 'Cisco 9871',
          'YEALINK T85', 'YEALINK T87',
        ];

        const mobileAppFocQty = prev.reduce((sum, item) =>
          HANDSET_NAMES.includes(item.name) ? sum + (item.focQuantity || 0) : sum
        , 0);

        // ← This is the clean place to sync linesFoc, reading post-update state
        setLinesFoc(linesFocPrev => ({
          ...linesFocPrev,
          hostedLifetimeLicenses: mobileAppFocQty > 0,
          hostedLifetimeLicensesFocQty: mobileAppFocQty,
        }));

        return prev; // no further hardware change needed
      });
    }

    setHasUnsavedChanges(true);
  };

  const groupedItems = hardwareItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  const calculateAllCosts = useMemo(() => {
    if (!services || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
      return { totalMonthly: 0 };
    }

    const getPrice = (serviceName) => {
      const service = services.find(s => s.name === serviceName);
      const price = service ? parseFloat(service.price) : 0;
      return parseFloat(price.toFixed(2));
    };

    const roundToTwo = (num) => {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    };

    const fibre_fail_safe_sum = currentLines.adslFttcBroadband + currentLines.new4g5gBroadband + currentLines.fttpSogeaBroadband;
     
    const costs = {
      sogea: roundToTwo(currentLines.fttpSogeaBroadband * getPrice('SOGEA')),
      adsl: roundToTwo(currentLines.adslFttcBroadband * getPrice('FTTC BB')),
      fourG5g: roundToTwo(currentLines.new4g5gBroadband * getPrice('4G BB')),
      starlink: roundToTwo(dataBroadband.starlinkBroadband * getPrice('STARLINK')),
      analogue: roundToTwo(currentLines.analoguePstnLines * getPrice('ANALOGUE LINE')),
      isdn2: roundToTwo(lineRequirements.existingIsdn2Channels * getPrice('ISDN 2 CH')),
      t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getPrice('T58W')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getPrice('T57W')),
      t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getPrice('T54W')),
      t85: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T85')?.quantity || 0) * getPrice('YEALINK T85')),
      t87: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T87')?.quantity || 0) * getPrice('YEALINK T87')),
      yealink: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T88')?.quantity || 0) * getPrice('YEALINK T88')),
      dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getPrice('DECT')),
      mobileApp: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('LICENSE MAINT')),
      fibre_safe: getPrice('FIBRE SAFE'),
      isdn_2_ch: getPrice('ISDN 2 CH'),
      fibre_web_listing: getPrice('FIBRE AI'),
      fibre_audio: roundToTwo(hardwareItems.find(i => i.name === 'Fibre Audio')?.quantity || 0) + getPrice('FIBRE AUDIO'),
      sip_trunck: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('SIP TRUNK BUNDLE')),
      fibre_fail_safe: roundToTwo(fibre_fail_safe_sum * getPrice('FIBRE FAILSAFE')),
     // leased_line: roundToTwo(dataBroadband.leasedLines * getPrice('LEASED LINE')),
      grandstream3470: roundToTwo((hardwareItems.find(i => i.name === 'Grandstream 3470')?.quantity || 0) * getPrice('GRANDSTREAM 3470')),
      grandstream3480: roundToTwo((hardwareItems.find(i => i.name === 'Grandstream 3480')?.quantity || 0) * getPrice('GRANDSTREAM 3480')),
      cisco9871: roundToTwo((hardwareItems.find(i => i.name === 'Cisco 9871')?.quantity || 0) * getPrice('CISCO 9871')),

    };
   

    costs.totalMonthly = roundToTwo(
      Object.values(costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
    );

    return costs;
  }, [services, currentLines, dataBroadband, lineRequirements, hardwareItems]);

  const calculateTotalHardwareCosts = useMemo(() => {
    if (!equipments || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
      return { totalMonthly: 0 };
    }

    const getEquipmentPrice = (equipmentName) => {
      const equipment = equipments.find(s => s.name === equipmentName);
      const price = equipment ? parseFloat(equipment.price) : 0;
      return parseFloat(price.toFixed(2));
    };

    const roundToTwo = (num) => {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    };
    
    const doorEntryQuantity = 
      (additionalHardware.find(i => i.name === 'Pancode')?.quantity || 0) +
      (additionalHardware.find(i => i.name === '1 Button Entry')?.quantity || 0);

    const cable5e = 
      (hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'T58W')?.quantity || 0)+
      (hardwareItems.find(i => i.name === 'YEALINK T88')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'YEALINK T85')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'YEALINK T87')?.quantity || 0)+
      (hardwareItems.find(i => i.name === 'Grandstream 3470')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'Grandstream 3480')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'Cisco 9871')?.quantity || 0);

    const lg_tv =
      (hardwareItems.find(i => i.name === 'Fibre TV/Wallboard')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'Add On')?.quantity || 0);

    const equiment_costs = {
      hostedLifetimeLicenses: roundToTwo(currentLines.hostedLifetimeLicenses * getEquipmentPrice('SINGLE LIFETIME HOSTED LICENSE')),
      t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getEquipmentPrice('T54W')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getEquipmentPrice('T57W')),
      t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getEquipmentPrice('T58W PRO')),
      t85: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T85')?.quantity || 0) * getEquipmentPrice('YEALINK T85')),
      t87: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T87')?.quantity || 0) * getEquipmentPrice('YEALINK T87')),
      yealink: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T88')?.quantity || 0) * getEquipmentPrice('YEALINK T88')),
      number_port: getEquipmentPrice('NUMBER PORT'),
      new_number: getEquipmentPrice('NEW NUMBER PROVISION 2-9'),
      dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getEquipmentPrice('IP DECT')),
      bell: roundToTwo((hardwareItems.find(i => i.name === 'Bell / Tannoy')?.quantity || 0) * getEquipmentPrice('SIPP BELL')),
      headset: roundToTwo((hardwareItems.find(i => i.name === 'Headsets')?.quantity || 0) * getEquipmentPrice('WIRELESS HEADSET')),
      doorentry: roundToTwo(doorEntryQuantity * getEquipmentPrice('DOOR ENTRY SYSTEM (AVERAGE ONE)')),
      ipad: roundToTwo((hardwareItems.find(i => i.name === 'iPad')?.quantity || 0) * getEquipmentPrice('IPAD')),
      cat5e: roundToTwo((additionalHardware.find(i => i.name === 'Cat 5')?.quantity || 0) * getEquipmentPrice('CAT 5E CABLING')),
      sitemove: roundToTwo((additionalHardware.find(i => i.name === 'System Moves')?.quantity || 0) * getEquipmentPrice('SITE MOVE')),
      poe_switch: getEquipmentPrice('Netgear GS108LP SWITCH'),
      draytek_wifi: getEquipmentPrice('DRAYTEK WI-FI ROUTER'),
      robustel_4g_router: roundToTwo(currentLines.new4g5gBroadband * getEquipmentPrice('ROBUSTEL 4G ROUTER')),
      new_base_line: roundToTwo(currentLines.analoguePstnLines * getEquipmentPrice('NEW BASIC LINE')),
      override_comms: getEquipmentPrice('OVERRIDE COMMS'),
      tital_cat5cable: (cable5e * getEquipmentPrice('TITAL CAT 5 CABLE (2M)')),
      installation_charge: getEquipmentPrice('INSTALLATION CHARGE'),
      wifi: roundToTwo((hardwareItems.find(i => i.name === 'Wi-Fi Booster')?.quantity || 0) * getEquipmentPrice('WIFI BOOSTER')),
      lg_tv: roundToTwo(lg_tv * getEquipmentPrice('LG TV')),
      star_link: roundToTwo(dataBroadband.starlinkBroadband * getEquipmentPrice('STARLINK')),
      admin_fee: getEquipmentPrice('ADMIN FEE'),
      grandstream3470: roundToTwo((hardwareItems.find(i => i.name === 'Grandstream 3470')?.quantity || 0) * getEquipmentPrice('GRANDSTREAM 3470')),
      grandstream3480: roundToTwo((hardwareItems.find(i => i.name === 'Grandstream 3480')?.quantity || 0) * getEquipmentPrice('GRANDSTREAM 3480')),
      cisco9871: roundToTwo((hardwareItems.find(i => i.name === 'Cisco 9871')?.quantity || 0) * getEquipmentPrice('CISCO 9871')),

    };
    
    equiment_costs.totalCost = roundToTwo(
      Object.values(equiment_costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
    );
    
    return equiment_costs;
  }, [services, equipments, currentLines, dataBroadband, lineRequirements, hardwareItems, additionalHardware]);

  const calculateItServicesCost = useMemo(() => {
    const stations = parseInt(itServicesData.numberOfStations) || 0;

    const getItSupportPrice = (name) => {
      const item = itSupportPricing.find(i => i.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };

    const getLicencePrice = (name) => {
      const item = licenses.find(l => l.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };

    const roundToTwo = (num) => parseFloat((Math.round(num * 100) / 100).toFixed(2));

    const licenceBreakdown = licenses.map(license => {
      const qty = parseInt(itServicesData.licenceQuantities[license.id]) || 0;
      const price = parseFloat(license.price) || 0;
      return {
        id: license.id,
        name: license.name,
        price,
        quantity: qty,
        lineTotal: roundToTwo(qty * price)
      };
    });

    const licenceCost = roundToTwo(
      licenceBreakdown.reduce((sum, l) => sum + l.lineTotal, 0)
    );
    const totalLicenceQuantity = licenceBreakdown.reduce((sum, l) => sum + l.quantity, 0);

    const itSupportPrice = getItSupportPrice('IT SUPPORT (PER STATION)');
    const basePerStationPrice = getItSupportPrice('PER STATION + MICROSOFT LICENCE BASIC');
    const standardLicencePrice = getLicencePrice('MICROSOFT BUSINESS STANDARD');
    const premiumLicencePrice = getLicencePrice('MICROSOFT BUSINESS PREMIUM');
    const itServicePrice = getItSupportPrice('IT SERVICE');

    // ── Per-station package options — pick one per station ──
    const stationPackages = {
      it_support: { label: 'IT Support only', price: itSupportPrice },
      basic: { label: '+ Microsoft Business Basic', price: basePerStationPrice },
      standard: { label: '+ Microsoft Business Standard', price: roundToTwo(basePerStationPrice + standardLicencePrice) },
      premium: { label: '+ Microsoft Business Premium', price: roundToTwo(basePerStationPrice + premiumLicencePrice) },
    };

    const selectedKeys = itServicesData.selectedPackages || [];
    const perStationPrice = roundToTwo(
      selectedKeys.reduce((sum, key) => sum + (stationPackages[key]?.price || 0), 0)
    );
    const stationCost = roundToTwo(stations * perStationPrice);

    const itServiceCost = roundToTwo(itServicePrice);

    const total = roundToTwo(licenceCost + stationCost + itServiceCost);

    return {
      licenceBreakdown,
      licenceCost,
      totalLicenceQuantity,
      stationPackages,
      perStationPrice,
      stationCost,
      itServicePrice,
      itServiceCost,
      total,
    };
  }, [itServicesData, licenses, itSupportPricing]);
  const handleFocus = (key, valueSetter) => (e) => {
    if (e.target.value === '0') {
      valueSetter(key, '');
    }
  };

  const handleBlur = (key, valueSetter) => (e) => {
    if (e.target.value === '') {
      valueSetter(key, '0');
    }
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleServiceChargesData = (data) => {
    setServiceChargesData(data);
    setHasUnsavedChanges(true);
  };
  const handleSettlementChange = (field, value) => {
    setSettlement(prev => ({ ...prev, [field]: value }));
    setHasUnsavedChanges(true);
  };

  const handleLeaseDataUpdate = (leaseData) => {
    setLeaseCalculatorData(leaseData);
    setHasUnsavedChanges(true);
  };

 const handleSaveSystemConfig = async () => {
  setIsSaving(true);
  try {
    const systemConfigData = {
      connectionId: selectedConnectionId,
      lineRequirements,
      currentLines,
      dataBroadband,
      hardwareItems: hardwareItems.map(item => ({
        ...item,
        type: 'standard',
        
      })),
      additionalHardware: additionalHardware.map(item => ({
        ...item,
        type: 'additional',
      })),
      serviceCharges: serviceChargesData,
      itServices: itServicesData,
      itServicesTotal: calculateItServicesCost.total,
      totalMonthlyCost: calculateAllCosts.totalMonthly,
      leasedLines: dataBroadband.leasedLines,
      totalEquipmentCost: calculateTotalHardwareCosts.totalCost,
      leaseCalculatorData: {
        ...leaseCalculatorData,
        paymentProfile: leaseCalculatorData.paymentProfile.toString(),
        networkPayment: leaseCalculatorData.networkPayment.toString(),
        networkSettlementContribution: Number(
          leaseCalculatorData.networkSettlementContribution
        ),
        digital_services: {
          webHostingCost: digitalServicesData.webHostingCost ?? 0,
          totalNewDigitalCost: digitalServicesData.totalNewDigitalCost ?? 0,
          totalFibreDigitalRevenue: digitalServicesData.totalFibreDigitalRevenue ?? 0,
          axoSignalPackage: digitalServicesData.axoSignalPackage ?? null,
          licenceServices: digitalServicesData.licenceServices ?? {},
        },
      },
      telecom_services: telecomServices.map(service => ({
        description: service.description || '',
        existing_tel_no: service.existing_tel_no || '',
        postcode: service.postcode || '',
        quantity: service.quantity || 0,
        service_type: service.service_type || '',
      })),
      linesFoc,
      save_to_draft: 1,
      notes: notes,
    };

    let result;

    if (existingConfigId) {
      result = await updateSystemConfig(existingConfigId, systemConfigData);
    } else {
      result = await saveSystemConfig(systemConfigData);
      if (result?.id) {
        setExistingConfigId(result.id);
      }
    }

    // QuoteProgressService failing shouldn't be treated as the whole save failing —
    // but log it so it's visible if it ever does.
    try {
      await QuoteProgressService.saveStep({
        quoteId: selectedConnectionId,
        stepName: "system_config",
        completed: true,
        actions: {},
      });
    } catch (progressError) {
      console.error("Failed to update quote progress step:", progressError);
    }

        // Save settlement details (separate table — used by the Rental Agreement)
    try {
      const token = localStorage.getItem('authToken');
      await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/rental-settlement/${selectedConnectionId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            existing_finance_company: settlement.existingFinanceCompany || null,
            existing_agreement_ref:   settlement.existingAgreementRef || null,
            settlement_amount:        settlement.settlementAmount === '' ? null : String(settlement.settlementAmount),
          }),
        }
      );
    } catch (settlementError) {
      console.error('Failed to save settlement details:', settlementError);
    }
        // Save special conditions (same field the Contract "Special Conditions" box uses)
    try {
      await saveContractNotes(selectedConnectionId, { specialConditions });
    } catch (specialError) {
      console.error('Failed to save special conditions:', specialError);
    }

    isInitialLoad.current = true;
    setHasUnsavedChanges(false);
    setSavedOnce(true);

    if (typeof onBack === "function") {
      onBack();
    }

    return result;
  } catch (error) {
    console.error("Operation failed:", error);

    // fetch() throws a TypeError('Failed to fetch') when the request never
    // reaches the server — offline, DNS failure, dropped connection, CORS block.
    const isNetworkIssue =
      !navigator.onLine ||
      (error instanceof TypeError && /fetch/i.test(error.message));

    if (isNetworkIssue) {
      alert(
        "⚠️ Could not save — you appear to be offline or your connection dropped.\n\n" +
        "Nothing was saved. Please check your internet connection and click Update again before leaving this page."
      );
    } else {
      alert(
        "⚠️ Failed to save the system configuration.\n\n" +
        "Nothing was saved. Please try again. If this keeps happening, contact support."
      );
    }

    // Deliberately leave hasUnsavedChanges = true and don't call onBack() —
    // the orange "unsaved changes" banner must stay visible so the user knows
    // this record still needs saving.
  } finally {
    setIsSaving(false);
  }
};

  // ── Shared Update button renderer — used at top and bottom ──
  const UpdateButton = ({ size = 'normal' }) => (
    <button
      type="button"
      onClick={handleSaveSystemConfig}
      disabled={isSaving}
      className={`relative bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 
        text-white rounded-lg font-semibold flex items-center space-x-2 disabled:opacity-50 transition-all duration-200
        ${size === 'large' ? 'px-8 py-3 text-base' : 'px-6 py-2.5 text-sm'}
        ${hasUnsavedChanges ? 'shadow-lg shadow-orange-300/50 ring-2 ring-orange-400 ring-offset-1' : ''}
      `}
    >
      {/* Pulsing dot when there are unsaved changes */}
      {hasUnsavedChanges && !isSaving && (
        <span className="absolute -top-1.5 -right-1.5 flex h-3.5 w-3.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-orange-500"></span>
        </span>
      )}
      {isSaving ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          <span>Saving...</span>
        </>
      ) : (
        <>
          <CheckCircle className="w-4 h-4" />
          <span>Update</span>
        </>
      )}
    </button>
  );
  

  if (isLoadingConfig) {
    return (
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-blue-100 p-8">
        <div className="flex items-center justify-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="text-blue-600 font-medium">Loading configuration...</span>
        </div>
      </div>
    );
  }

  if (configError) {
    return (
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-red-100 p-8">
        <div className="flex items-center justify-center space-x-3 text-red-600">
          <AlertCircle className="w-8 h-8" />
          <span className="font-medium">{configError}</span>
        </div>
        <div className="mt-4 text-center">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-blue-100">

      {/* ── TOP ACTION BAR ── */}
      <div className={`px-6 py-4 flex items-center justify-between border-b transition-colors duration-300
        ${hasUnsavedChanges
          ? 'bg-gradient-to-r from-orange-50 to-amber-50 border-orange-200'
          : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-100'
        }`}
      >
        <div className="flex items-center space-x-3">
          <Settings className="w-5 h-5 text-blue-700" />
          <div>
            <p className="text-sm font-semibold text-gray-800">System Configuration</p>
            {hasUnsavedChanges ? (
              <p className="text-xs text-orange-600 font-medium flex items-center space-x-1">
                <span className="inline-block w-1.5 h-1.5 bg-orange-500 rounded-full"></span>
                <span>Unsaved changes — click Update before leaving this page</span>
              </p>
            ) : savedOnce ? (
              <p className="text-xs text-green-600 font-medium flex items-center space-x-1">
                <CheckCircle className="w-3 h-3" />
                <span>All changes saved</span>
              </p>
            ) : (
              <p className="text-xs text-gray-500">Fill in the details below and click Update to save</p>
            )}
          </div>
        </div>
         <UpdateButton size="normal" />
        <div className="flex items-center space-x-3">
          <button
            type="button"
            onClick={() => setShowEditConnection(true)}
            className="px-4 py-2.5 text-sm font-semibold border-2 border-blue-600 text-blue-700 rounded-lg hover:bg-blue-50 flex items-center space-x-2 transition-all duration-200"
          >
            <Edit2 className="w-4 h-4" />
            <span>Edit Customer</span>
          </button>
         
        </div>
      
       {showEditConnection && (
        <AddConnection
          mode="edit"
          initialData={localConnection}   // ← was: connection
         onSaved={(updatedConnection) => {
            setLocalConnection((prev) => mergeNonEmpty(prev, updatedConnection));
            setShowEditConnection(false);
            if (onConnectionUpdated) onConnectionUpdated(updatedConnection);
          }}
          onClose={() => setShowEditConnection(false)}
        />
      )}
        
      </div>

      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsLineServicesOpen(!isLineServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Settings className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">LINE SERVICES</h2>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isLineServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isLineServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isLineServicesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          <TelecomServicesSection
            services={telecomServices}
            onServiceChange={handleServiceChange}
            onAddService={handleAddService}
            onRemoveService={handleRemoveService}
          />

          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 shadow-md">
            <div className="flex items-center justify-center space-x-2">
              <Wifi className="w-5 h-5" />
              <h3 className="font-bold text-lg">LINE REQUIREMENTS</h3>
            </div>
          </div>

          <div className="p-6">
            <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
              <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                <h4 className="font-semibold text-blue-800 text-center">
                  New Lines & Internet
                </h4>
              </div>

                <div className="space-y-1">
                {/* Hosted Lifetime Licenses */}
                          <div className="p-4 hover:bg-blue-50 transition-colors duration-200 border-b border-blue-100">
                            <div className="flex justify-between items-center">
                              <span className="text-gray-700 font-medium">
                                Hosted Lifetime Licenses with SIP Trunk
                                {canSeeFoc && linesFoc.hostedLifetimeLicensesFocQty > 0 && (
                                  <span className="ml-1 text-xs text-emerald-600 font-normal">
                                    ({currentLines.hostedLifetimeLicenses} + {linesFoc.hostedLifetimeLicensesFocQty} FOC)
                                  </span>
                                )}
                              </span>
                              <input
                                type="number"
                                value={currentLines.hostedLifetimeLicenses + (linesFoc.hostedLifetimeLicensesFocQty || 0)}
                                onChange={(e) => {
                                  const combined = parseInt(e.target.value) || 0;
                                  const base = Math.max(0, combined - (linesFoc.hostedLifetimeLicensesFocQty || 0));
                                  handleCurrentLinesChange('hostedLifetimeLicenses', base);
                                }}
                                onFocus={handleFocus('hostedLifetimeLicenses', handleCurrentLinesChange)}
                                onBlur={handleBlur('hostedLifetimeLicenses', handleCurrentLinesChange)}
                                className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                                min="0"
                              />
                            </div>
                            {canSeeFoc && (
                              <div className="flex items-center justify-between mt-2">
                                <label className="flex items-center space-x-2 cursor-pointer select-none">
                                  <input
                                    type="checkbox"
                                    checked={!!linesFoc.hostedLifetimeLicenses}
                                    onChange={(e) => {
                                      setLinesFoc(prev => ({ ...prev, hostedLifetimeLicenses: e.target.checked, hostedLifetimeLicensesFocQty: e.target.checked ? prev.hostedLifetimeLicensesFocQty : 0 }));
                                      setHasUnsavedChanges(true);
                                    }}
                                    className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                                  />
                                  <span className="text-xs font-semibold text-emerald-700">FOC</span>
                                </label>
                                {linesFoc.hostedLifetimeLicenses && (
                                  <input
                                    type="number"
                                    value={linesFoc.hostedLifetimeLicensesFocQty ?? 0}
                                    min="0"
                                    onChange={(e) => {
                                      setLinesFoc(prev => ({ ...prev, hostedLifetimeLicensesFocQty: parseInt(e.target.value) || 0 }));
                                      setHasUnsavedChanges(true);
                                    }}
                                    className="w-20 px-2 py-1 border-2 border-emerald-300 rounded-lg text-center font-semibold text-emerald-700 bg-emerald-50 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 text-sm"
                                  />
                                )}
                              </div>
                            )}
                          </div>

                {/* New 4G / 5G Broadband */}
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 border-b border-blue-100">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">
                      New 4G / 5G Broadband
                      {canSeeFoc && linesFoc.new4g5gBroadbandFocQty > 0 && (
                        <span className="ml-1 text-xs text-emerald-600 font-normal">
                          ({currentLines.new4g5gBroadband} + {linesFoc.new4g5gBroadbandFocQty} FOC)
                        </span>
                      )}
                    </span>
                    <input
                      type="number"
                      value={currentLines.new4g5gBroadband + (linesFoc.new4g5gBroadbandFocQty || 0)}
                      onChange={(e) => {
                        const combined = parseInt(e.target.value) || 0;
                        const base = Math.max(0, combined - (linesFoc.new4g5gBroadbandFocQty || 0));
                        handleCurrentLinesChange('new4g5gBroadband', base);
                      }}
                      onFocus={handleFocus('new4g5gBroadband', handleCurrentLinesChange)}
                      onBlur={handleBlur('new4g5gBroadband', handleCurrentLinesChange)}
                      className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                      min="0"
                    />
                  </div>
                  {canSeeFoc && (
                    <div className="flex items-center justify-between mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={!!linesFoc.new4g5gBroadband}
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, new4g5gBroadband: e.target.checked, new4g5gBroadbandFocQty: e.target.checked ? prev.new4g5gBroadbandFocQty : 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-emerald-700">FOC</span>
                      </label>
                      {linesFoc.new4g5gBroadband && (
                        <input
                          type="number"
                          value={linesFoc.new4g5gBroadbandFocQty ?? 0}
                          min="0"
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, new4g5gBroadbandFocQty: parseInt(e.target.value) || 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-20 px-2 py-1 border-2 border-emerald-300 rounded-lg text-center font-semibold text-emerald-700 bg-emerald-50 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 text-sm"
                        />
                      )}
                    </div>
                  )}
                </div>

                {/* FTTP / SoGEA Broadband */}
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 border-b border-blue-100">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">
                      FTTP / SoGEA Broadband
                      {canSeeFoc && linesFoc.fttpSogeaBroadbandFocQty > 0 && (
                        <span className="ml-1 text-xs text-emerald-600 font-normal">
                          ({currentLines.fttpSogeaBroadband} + {linesFoc.fttpSogeaBroadbandFocQty} FOC)
                        </span>
                      )}
                    </span>
                    <input
                      type="number"
                      value={currentLines.fttpSogeaBroadband + (linesFoc.fttpSogeaBroadbandFocQty || 0)}
                      onChange={(e) => {
                        const combined = parseInt(e.target.value) || 0;
                        const base = Math.max(0, combined - (linesFoc.fttpSogeaBroadbandFocQty || 0));
                        handleCurrentLinesChange('fttpSogeaBroadband', base);
                      }}
                      onFocus={handleFocus('fttpSogeaBroadband', handleCurrentLinesChange)}
                      onBlur={handleBlur('fttpSogeaBroadband', handleCurrentLinesChange)}
                      className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                      min="0"
                    />
                  </div>
                  {canSeeFoc && (
                    <div className="flex items-center justify-between mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={!!linesFoc.fttpSogeaBroadband}
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, fttpSogeaBroadband: e.target.checked, fttpSogeaBroadbandFocQty: e.target.checked ? prev.fttpSogeaBroadbandFocQty : 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-emerald-700">FOC</span>
                      </label>
                      {linesFoc.fttpSogeaBroadband && (
                        <input
                          type="number"
                          value={linesFoc.fttpSogeaBroadbandFocQty ?? 0}
                          min="0"
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, fttpSogeaBroadbandFocQty: parseInt(e.target.value) || 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-20 px-2 py-1 border-2 border-emerald-300 rounded-lg text-center font-semibold text-emerald-700 bg-emerald-50 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 text-sm"
                        />
                      )}
                    </div>
                  )}
                </div>

                {/* Starlink Broadband */}
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 border-b border-blue-100">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">
                      Starlink Broadband
                      {canSeeFoc && linesFoc.starlinkBroadbandFocQty > 0 && (
                        <span className="ml-1 text-xs text-emerald-600 font-normal">
                          ({dataBroadband.starlinkBroadband} + {linesFoc.starlinkBroadbandFocQty} FOC)
                        </span>
                      )}
                    </span>
                    <input
                      type="number"
                      value={dataBroadband.starlinkBroadband + (linesFoc.starlinkBroadbandFocQty || 0)}
                      onChange={(e) => {
                        const combined = parseInt(e.target.value) || 0;
                        const base = Math.max(0, combined - (linesFoc.starlinkBroadbandFocQty || 0));
                        handleDataBroadbandChange('starlinkBroadband', base);
                      }}
                      onFocus={handleFocus('starlinkBroadband', handleDataBroadbandChange)}
                      onBlur={handleBlur('starlinkBroadband', handleDataBroadbandChange)}
                      className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                      min="0"
                    />
                  </div>
                  {canSeeFoc && (
                    <div className="flex items-center justify-between mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={!!linesFoc.starlinkBroadband}
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, starlinkBroadband: e.target.checked, starlinkBroadbandFocQty: e.target.checked ? prev.starlinkBroadbandFocQty : 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-emerald-700">FOC</span>
                      </label>
                      {linesFoc.starlinkBroadband && (
                        <input
                          type="number"
                          value={linesFoc.starlinkBroadbandFocQty ?? 0}
                          min="0"
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, starlinkBroadbandFocQty: parseInt(e.target.value) || 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-20 px-2 py-1 border-2 border-emerald-300 rounded-lg text-center font-semibold text-emerald-700 bg-emerald-50 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 text-sm"
                        />
                      )}
                    </div>
                  )}
                </div>

                {/* Leased Lines */}
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">
                      Leased Lines
                      {canSeeFoc && linesFoc.leasedLinesFocQty > 0 && (
                        <span className="ml-1 text-xs text-emerald-600 font-normal">
                          ({dataBroadband.leasedLines} + {linesFoc.leasedLinesFocQty} FOC)
                        </span>
                      )}
                    </span>
                    <input
                      type="number"
                      value={dataBroadband.leasedLines + (linesFoc.leasedLinesFocQty || 0)}
                      onChange={(e) => {
                        const combined = parseInt(e.target.value) || 0;
                        const base = Math.max(0, combined - (linesFoc.leasedLinesFocQty || 0));
                        handleDataBroadbandChange('leasedLines', base);
                      }}
                      onFocus={handleFocus('leasedLines', handleDataBroadbandChange)}
                      onBlur={handleBlur('leasedLines', handleDataBroadbandChange)}
                      className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                      min="0"
                    />
                  </div>
                  {canSeeFoc && (
                    <div className="flex items-center justify-between mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={!!linesFoc.leasedLines}
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, leasedLines: e.target.checked, leasedLinesFocQty: e.target.checked ? prev.leasedLinesFocQty : 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-emerald-700">FOC</span>
                      </label>
                      {linesFoc.leasedLines && (
                        <input
                          type="number"
                          value={linesFoc.leasedLinesFocQty ?? 0}
                          min="0"
                          onChange={(e) => {
                            setLinesFoc(prev => ({ ...prev, leasedLinesFocQty: parseInt(e.target.value) || 0 }));
                            setHasUnsavedChanges(true);
                          }}
                          className="w-20 px-2 py-1 border-2 border-emerald-300 rounded-lg text-center font-semibold text-emerald-700 bg-emerald-50 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 text-sm"
                        />
                      )}
                    </div>
                  )}
                </div>
                </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsHardwareOpen(!isHardwareOpen)}
      >
        <div className="flex items-center space-x-3">
          <Monitor className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">HARDWARE</h2>
          <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
            {hardwareItems.length} items
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isHardwareOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isHardwareOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isHardwareOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          <div className="p-6 space-y-6">
            {Object.entries(groupedItems).map(([category, items]) => (
              <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      {getIconComponent(category)}
                      <h4 className="font-bold text-blue-800">{category}</h4>
                      <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                        {items.length}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Dropdown selector — Phone category only */}
               

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                 {items.map(item => (
                      <div key={item.id} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200 hover:shadow-md transition-all duration-200">
                        <div className="flex justify-between items-start mb-3">
                          <div className="flex items-center space-x-3">
                            {(item.icon && typeof item.icon === 'string' && item.icon.startsWith('/images')) ? (
                              <img
                                src={item.icon}
                                alt={item.name}
                                className="w-13 h-12 object-contain rounded-md"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = '/images/placeholder.jpg';
                                  e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                                }}
                              />
                            ) : (
                              <span className="text-2xl">{(item.icon && typeof item.icon === 'string') ? item.icon : '⚙️'}</span>
                            )}
                            <div>
                              {editingId === item.id ? (
                                <input
                                  type="text"
                                  value={item.name}
                                  onChange={(e) => handleEditItem(item.id, 'name', e.target.value)}
                                  className="font-semibold text-gray-800 bg-white border border-blue-300 rounded px-2 py-1 text-sm"
                                  onBlur={() => setEditingId(null)}
                                  onKeyPress={(e) => e.key === 'Enter' && setEditingId(null)}
                                  autoFocus
                                />
                              ) : (
                                <h5 className="font-semibold text-gray-800 cursor-pointer hover:text-blue-600">
                                  {item.name}
                                </h5>
                              )}
                              <p className="text-xs text-gray-600">{item.category}</p>
                            </div>
                          </div>
                        </div>

                        <div className="flex flex-col space-y-2">
                          <div className="flex items-center justify-between">
                            <span className="text-sm font-medium text-gray-600">
                              Quantity:
                              {canSeeFoc && (item.focQuantity || 0) > 0 && (
                                <span className="ml-1 text-xs text-emerald-600 font-normal">
                                  ({item.quantity} + {item.focQuantity} FOC)
                                </span>
                              )}
                            </span>
<input
  type="number"
  disabled={['T54W', 'T57W', 'T58W'].includes(item.name)}
  value={
    focDraftValues[`qty-${item.id}`] !== undefined
      ? focDraftValues[`qty-${item.id}`]
      : item.manuallySet
        ? item.quantity + (item.focQuantity || 0)
        : (item.quantity || 0) + (item.focQuantity || 0)
  }
  onFocus={() => {
    const current = (item.quantity || 0) + (item.focQuantity || 0);
    setFocDraftValues(prev => ({
      ...prev,
      [`qty-${item.id}`]: current === 0 ? '' : String(current)
    }));
  }}
  onChange={(e) => {
    setFocDraftValues(prev => ({ ...prev, [`qty-${item.id}`]: e.target.value }));
  }}
 onBlur={(e) => {
  const combined = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
  const baseQty = Math.max(0, combined - (item.focQuantity || 0));
  setFocDraftValues(prev => { const next = { ...prev }; delete next[`qty-${item.id}`]; return next; });
  if (baseQty !== (item.quantity || 0)) {          // ← add this guard
    handleEditItem(item.id, 'quantity', baseQty);
  }
}}
  className={`w-20 px-2 py-1 border border-blue-300 rounded-lg text-right font-semibold text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200 ${
    ['T54W', 'T57W', 'T58W'].includes(item.name) ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
  }`}
  min="0"
/>
                          </div>

                          {canSeeFoc && (
                            <div className="flex items-center justify-between pt-1 border-t border-blue-100 mt-1">
                              <label className="flex items-center space-x-2 cursor-pointer select-none">
                                <input
                                  type="checkbox"
                                  disabled={['T54W', 'T57W', 'T58W'].includes(item.name)}
                                  checked={!!item.foc}
                                  onChange={(e) => handleFocChange(item.id, 'foc', e.target.checked)}
                                  className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
                                />
                                <span className="text-xs font-semibold text-emerald-700">FOC</span>
                              </label>
                                {item.foc && !['T54W', 'T57W', 'T58W'].includes(item.name) && (
                                  <input
                                    type="number"
                                    value={focDraftValues[item.id] !== undefined ? focDraftValues[item.id] : (item.focQuantity ?? 0)}
                                    min="0"
                                    onFocus={() =>
                                      setFocDraftValues(prev => ({ ...prev, [item.id]: item.focQuantity ?? 0 }))
                                    }
                                    onChange={(e) =>
                                      setFocDraftValues(prev => ({ ...prev, [item.id]: e.target.value }))
                                    }
                                   onBlur={(e) => {
  const val = parseInt(e.target.value) || 0;
  setFocDraftValues(prev => { const next = { ...prev }; delete next[item.id]; return next; });
  if (val !== (item.focQuantity || 0)) {           // ← add this guard
    handleFocChange(item.id, 'focQuantity', val);
  }
}}
                                    className="w-20 px-2 py-1 border-2 border-emerald-300 ..."
                                  />
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>

          {/* Additional Hardware */}
          <div className="p-6 space-y-6">
            {Object.entries(
              additionalHardware.reduce((acc, item) => {
                acc[item.category] = acc[item.category] || [];
                acc[item.category].push(item);
                return acc;
              }, {})
            ).map(([category, items]) => (
              <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                  <div className="flex items-center space-x-2">
                    {getIconComponent(category)}
                    <h4 className="font-bold text-blue-800">{category}</h4>
                    <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                      {items.length}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                  {items.map((item) => {
                    if (item.name === 'Draytek 2865LAC' || item.name === 'Netgear GS108LP') {
    console.log('[RENDER]', item.name, { quantity: item.quantity, focQuantity: item.focQuantity, manuallySet: item.manuallySet });
  }
                    const isEmail = item.category === 'E-mail';
                    const otherTotal = 90;
                    const computedQuantity = isEmail
                      ? (parseInt(emailExtraInput) || 0) + otherTotal
                      : item.quantity;

                    return (
                      <div
                        key={item.id || item.name}
                        className="bg-white border border-blue-200 rounded-xl p-4 shadow-sm transition hover:shadow-md space-y-4"
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <div className="flex items-center space-x-3 mb-2">
                              {(item.icon && typeof item.icon === 'string' && item.icon.startsWith('/images')) ? (
                                <img
                                  src={item.icon}
                                  alt={item.name || item.description || 'Hardware item'}
                                  className="w-12 h-12 object-contain rounded-md"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = '/images/placeholder.jpg';
                                    e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                                  }}
                                />
                              ) : (
                                <span className="text-2xl">{(item.icon && typeof item.icon === 'string') ? item.icon : '⚙️'}</span>
                              )}
                              <div>
                                <h5 className="font-semibold text-blue-800">{item.name}</h5>
                                <p className="text-xs text-gray-500">{item.category}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-between items-center">
                          <label className="text-sm text-gray-700 font-medium">
                            Quantity
                            {item.manuallySet && (
    <span className="ml-1 text-xs text-amber-600 font-normal">(manual)</span>
  )}
                            {canSeeFoc && (item.focQuantity || 0) > 0 && (
                              <span className="ml-1 text-xs text-emerald-600 font-normal">
                                ({item.quantity} + {item.focQuantity} FOC)
                              </span>
                            )}
                          </label>
 <input
  type="number"
  value={
    focDraftValues[`qty-${item.id}`] !== undefined
      ? focDraftValues[`qty-${item.id}`]
      : item.manuallySet
        ? item.quantity + (item.focQuantity || 0)
        : (item.quantity || 0) + (item.focQuantity || 0)
  }
  onFocus={() => {
    const current = (item.quantity || 0) + (item.focQuantity || 0);
    setFocDraftValues(prev => ({
      ...prev,
      [`qty-${item.id}`]: current === 0 ? '' : String(current)
    }));
  }}
  onChange={(e) => {
    setFocDraftValues(prev => ({ ...prev, [`qty-${item.id}`]: e.target.value }));
  }}
 onBlur={(e) => {
  const combined = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
  const baseQty = Math.max(0, combined - (item.focQuantity || 0));
  setFocDraftValues(prev => { const next = { ...prev }; delete next[`qty-${item.id}`]; return next; });
  if (baseQty !== (item.quantity || 0)) {          // ← add this guard
    handleEditItem(item.id, 'quantity', baseQty);
  }
}}
  className="w-20 px-2 py-1 border border-blue-300 rounded-lg text-right font-semibold text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
  min="0"
/>
                        </div>

                        {canSeeFoc && (
                          <div className="flex items-center justify-between pt-2 border-t border-blue-100">
                            <label className="flex items-center space-x-2 cursor-pointer select-none">
                              <input
                                type="checkbox"
                                checked={!!item.foc}
                                onChange={(e) => handleFocChange(item.id, 'foc', e.target.checked, true)}
                                className="w-4 h-4 rounded border-gray-300 accent-emerald-500 cursor-pointer"
                              />
                              <span className="text-xs font-semibold text-emerald-700">FOC</span>
                            </label>
                           {item.foc && (
                                    <input
                                      type="number"
                                      value={focDraftValues[`add-${item.id}`] !== undefined ? focDraftValues[`add-${item.id}`] : (item.focQuantity ?? 0)}
                                      min="0"
                                      onFocus={() =>
                                        setFocDraftValues(prev => ({ ...prev, [`add-${item.id}`]: item.focQuantity ?? 0 }))
                                      }
                                      onChange={(e) =>
                                        setFocDraftValues(prev => ({ ...prev, [`add-${item.id}`]: e.target.value }))
                                      }
                                     onBlur={(e) => {
  const val = parseInt(e.target.value) || 0;
  setFocDraftValues(prev => { const next = { ...prev }; delete next[item.id]; return next; });
  if (val !== (item.focQuantity || 0)) {           // ← add this guard
    handleFocChange(item.id, 'focQuantity', val);
  }
}}
                                      className="w-20 px-2 py-1 border-2 border-emerald-300 ..."
                                    />
                                  )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
       {/* ── IT SERVICES / MICROSOFT LICENCE RESALE ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsItServicesOpen(!isItServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Globe className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">IT SERVICES & MICROSOFT LICENCES</h2>
          {calculateItServicesCost.total > 0 && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              £{calculateItServicesCost.total.toFixed(2)}/mo
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isItServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isItServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isItServicesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 space-y-6">

         {/* Microsoft licences */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Microsoft 365 Licences Only</h4>
            </div>
            {licenses.length === 0 ? (
              <div className="p-4 text-sm text-gray-500 text-center">
                No licence pricing found — add licences in the Mechanics Calculator first.
              </div>
            ) : (
              <div className="divide-y divide-blue-100">
                {licenses.map(license => {
                  const qty = itServicesData.licenceQuantities[license.id] ?? 0;
                  const lineTotal = calculateItServicesCost.licenceBreakdown.find(l => l.id === license.id)?.lineTotal || 0;
                  return (
                    <div key={license.id} className="p-4 hover:bg-blue-50 transition-colors duration-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <span className="text-gray-700 font-medium">{license.name}</span>
                          <span className="ml-2 text-xs text-gray-500">
                            £{parseFloat(license.price).toFixed(2)} / licence / month
                          </span>
                        </div>
                        <div className="flex items-center space-x-3">
                          <input
                            type="number"
                            value={qty}
                            onChange={(e) => handleLicenceQuantityChange(license.id, e.target.value)}
                            onFocus={handleFocus(license.id, () => {})}
                            className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                            min="0"
                            placeholder="0"
                          />
                          <span className="w-20 text-right text-sm font-semibold text-gray-700">
                            £{lineTotal.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
         
         
          {/* Stations & IT Service charge */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Stations & IT Service</h4>
            </div>
            <div className="p-4 space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-700 font-medium">Number of Stations</span>
                <input
                  type="number"
                  value={itServicesData.numberOfStations}
                  onChange={(e) => handleStationsChange(e.target.value)}
                  onFocus={handleFocus('numberOfStations', (field, val) => handleStationsChange(val))}
                  onBlur={handleBlur('numberOfStations', (field, val) => handleStationsChange(val))}
                  className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                  min="0"
                />
              </div>

              <div className="pt-3 border-t border-blue-100">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Station Package (per station — select any combination)
                </label>
                <div className="space-y-2">
                  {Object.entries(calculateItServicesCost.stationPackages).map(([key, pkg]) => (
                    <label
                      key={key}
                      className="flex items-center justify-between p-2 rounded-lg border border-blue-100 hover:bg-blue-50 cursor-pointer"
                    >
                      <span className="flex items-center space-x-2">
                         <input
                          type="checkbox"
                          checked={(itServicesData.selectedPackages || []).includes(key)}
                          onChange={(e) => handleTogglePackage(key, e.target.checked)}
                          className="w-4 h-4 rounded accent-blue-500 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">{pkg.label}</span>
                      </span>
                      <span className="text-sm font-semibold text-blue-700">
                        £{pkg.price.toFixed(2)} / station
                      </span>
                    </label>
                  ))}
                </div>
              </div>

               <div className="flex justify-between items-center pt-3 border-t border-blue-100">
                <span className="text-sm font-medium text-gray-700">
                  Total ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})
                </span>
                <span className="text-sm font-bold text-blue-700">
                  £{calculateItServicesCost.stationCost.toFixed(2)}
                </span>
              </div>
            </div>
          </div>


          

          {/* Summary */}
          <div className="max-w-3xl mx-auto bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200 p-4 space-y-2">
            <div className="flex justify-between text-sm text-gray-600">
              <span>Microsoft licences ({calculateItServicesCost.totalLicenceQuantity} total)</span>
              <span>£{calculateItServicesCost.licenceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>Station packages ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})</span>
              <span>£{calculateItServicesCost.stationCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>IT service charge</span>
              <span>£{calculateItServicesCost.itServiceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-blue-200">
              <span className="text-sm font-semibold text-gray-800">Total</span>
              <span className="text-lg font-bold text-green-600">
                £{calculateItServicesCost.total.toFixed(2)} / month
              </span>
            </div>
          </div>
        </div>
      )}


      <CallCostsComponent
        isHostedLifetimeLicenses={currentLines.hostedLifetimeLicenses}
        selectedConnectionId={selectedConnectionId}
        totalMonthlyCost={calculateAllCosts.totalMonthly}
        itServicesTotal={calculateItServicesCost.total}
        leasedLines={dataBroadband.leasedLines}
        totalEquipmentCost={calculateTotalHardwareCosts.totalCost}
        onServiceChargesUpdate={handleServiceChargesData}
        onLeaseDataUpdate={handleLeaseDataUpdate}
        serviceChargesData={serviceChargesData}
        leaseCalculatorData={leaseCalculatorData}
        hardwareItems={hardwareItems}
        additionalHardware={additionalHardware}
        currentLines={currentLines}
        dataBroadband={dataBroadband}
        lineRequirements={lineRequirements}
        telecomServices={telecomServices}
        adminUpdate={adminUpdate}
        onDigitalServicesUpdate={handleDigitalServicesUpdate}
        savedDigitalServices={savedDigitalServices}
      />
            {/* ── NOTES SECTION ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsNotesOpen(!isNotesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Edit2 className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">NOTES</h2>
          {notes.trim() && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              {notes.trim().split(/\s+/).length} words
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isNotesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isNotesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isNotesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Internal Notes</h4>
            </div>
            <div className="p-4">
              <textarea
                value={notes}
                onChange={(e) => {
                  setNotes(e.target.value);
                  setHasUnsavedChanges(true);
                }}
                placeholder="Add any internal notes about this customer or configuration here..."
                rows={8}
                className="w-full px-4 py-3 border-2 border-blue-200 rounded-lg text-gray-700 text-sm leading-relaxed resize-y focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 placeholder-gray-400"
              />
              <p className="text-xs text-gray-400 mt-2 text-right">
                {notes.length} characters
              </p>
            </div>
          </div>
        </div>
      )}

            {/* ── SETTLEMENT OF EXISTING FINANCE AGREEMENT ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsSettlementOpen(!isSettlementOpen)}
      >
        <div className="flex items-center space-x-3">
          <Building2 className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">SETTLEMENT OF EXISTING FINANCE</h2>
          {(settlement.existingFinanceCompany || settlement.existingAgreementRef || settlement.settlementAmount) && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              Added
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isSettlementOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isSettlementOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isSettlementOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Upgrade or Settlement of Existing Finance Agreement</h4>
            </div>
            <div className="p-4 space-y-4">
              <p className="text-xs text-gray-500">
                Leave blank if not applicable. These values appear on the Rental Agreement.
              </p>
              {[
                { label: 'Finance company that owns the existing Goods', k: 'existingFinanceCompany', ph: 'e.g. BNP Paribas Leasing' },
                { label: 'Agreement reference number',                   k: 'existingAgreementRef',   ph: 'e.g. AGR-123456' },
                { label: 'Amount needed to settle current agreement',    k: 'settlementAmount',       ph: 'e.g. £1,250.00 or in words' },
              ].map(({ label, k, ph }) => (
                <div key={k} className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                  <span className="text-gray-700 font-medium text-sm md:w-1/2">{label}</span>
                  <input
                    type="text"
                    value={settlement[k]}
                    onChange={(e) => handleSettlementChange(k, e.target.value)}
                    placeholder={ph}
                    className="md:w-1/2 px-3 py-2 border-2 border-blue-200 rounded-lg text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

            {/* ── SPECIAL TERMS & CONDITIONS ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsSpecialTermsOpen(!isSpecialTermsOpen)}
      >
        <div className="flex items-center space-x-3">
          <AlertCircle className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">SPECIAL TERMS & CONDITIONS</h2>
          {specialConditions.trim() && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              Added
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isSpecialTermsOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isSpecialTermsOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isSpecialTermsOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Special Conditions</h4>
            </div>
            <div className="p-4">
              <p className="text-xs text-gray-500 mb-2">
                This appears on the Contract under "Special Conditions" in the Order Form.
              </p>
              <textarea
                value={specialConditions}
                onChange={(e) => {
                  setSpecialConditions(e.target.value);
                  setHasUnsavedChanges(true);
                }}
                placeholder="Enter any special terms agreed with the customer..."
                rows={6}
                className="w-full px-4 py-3 border-2 border-blue-200 rounded-lg text-gray-700 text-sm leading-relaxed resize-y focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 placeholder-gray-400"
              />
              <p className="text-xs text-gray-400 mt-2 text-right">
                {specialConditions.length} / 5000 characters
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ── BOTTOM SAVE BUTTON ── */}
      <div className="flex justify-end mt-6 px-2 pb-2">
        <UpdateButton size="large" />
      </div>
      
    </div>
  );
};

export default ExistingSystemConfig;